import React, { useState } from 'react';
import Icon from '../../../../components/Section/Icon';
import svg from '../../../../static/img/icon-open-collapse.svg';
import Info from '../../../../components/Section/SessionInfo';
import { ListSession } from '../../../../types/session';
import { SubTitleSpan } from '../../../../components/Section/SessionInfo/styles';
import { DivDeviceInfo, SessionItemList } from './styles';
import Action from '../../../../components/Section/Action';
import { MobileIcon } from '../../../../components/Section/Icon/MobileIcon/Mobile';
import { TVIcon } from '../../../../components/Section/Icon/TVIcon/TVIcon';
import { OtherDeviceIcon } from '../../../../components/Section/Icon/OtherDeviceIcon/OtherDeviceIcon';
import { DesktopIcon } from '../../../../components/Section/Icon/DesktopIcon/Desktop';

type Props = {
  itemSession: ListSession;
  isBetaUser: boolean;
  removeSessionState: (sessionIds: string[]) => void;
};

const DropDownSession = ({
  itemSession,
  isBetaUser,
  removeSessionState,
}: Props) => {
  const isActiveSession = itemSession.sessions.some(
    session => session.isActive,
  );
  const [open, setOpen] = useState<boolean>(isActiveSession);

  const openDropDownSession = (e: any) => {
    if (e.currentTarget === e.target || e.target.ariaHasPopup === 'true') {
      setOpen(!open);
    }
  };

  const getDeviceIconFromActiveSession = (displayName: string) => {
    switch (displayName.toLowerCase()) {
      case 'desktop':
        return (
          <DesktopIcon
            onClick={() => setOpen(!open)}
            alt={`${itemSession.device}-icon`}
          />
        );
      case 'mobile':
        return (
          <MobileIcon
            onClick={() => setOpen(!open)}
            alt={`${itemSession.device}-icon`}
          />
        );
      case 'tv':
        return (
          <TVIcon
            onClick={() => setOpen(!open)}
            alt={`${itemSession.device}-icon`}
          />
        );
      default:
        return (
          <OtherDeviceIcon
            onClick={() => setOpen(!open)}
            alt={`${itemSession.device}-icon`}
          />
        );
    }
  };

  return (
    <>
      {itemSession.sessions.length > 0 && (
        <SessionItemList key={itemSession.device} onClick={openDropDownSession}>
          <Action
            aria-haspopup="true"
            aria-expanded={open}
            type="button"
            theme="button"
          >
            <div>
              {(() => {
                switch (itemSession.device.toLowerCase()) {
                  case 'activesession':
                    return getDeviceIconFromActiveSession(
                      itemSession.displayName,
                    );
                  case 'desktop':
                    return (
                      <DesktopIcon
                        onClick={() => setOpen(!open)}
                        alt={`${itemSession.device}-icon`}
                      />
                    );
                  case 'mobile':
                    return (
                      <MobileIcon
                        onClick={() => setOpen(!open)}
                        alt={`${itemSession.device}-icon`}
                      />
                    );
                  case 'tv':
                    return (
                      <TVIcon
                        onClick={() => setOpen(!open)}
                        alt={`${itemSession.device}-icon`}
                      />
                    );
                  default:
                    return (
                      <OtherDeviceIcon
                        onClick={() => setOpen(!open)}
                        alt={`${itemSession.device}-icon`}
                      />
                    );
                }
              })()}
              <DivDeviceInfo>
                <p>{itemSession.displayName}</p>
                {itemSession.sessions.map(
                  session =>
                    session.isActive && (
                      <SubTitleSpan key={session.sessionId}>
                        Dispositivo atual
                      </SubTitleSpan>
                    ),
                )}
              </DivDeviceInfo>
            </div>
            <div>
              <Icon
                openCollapsible={open}
                svg={svg}
                onClick={() => setOpen(!open)}
                alt="icon-open-menu"
              />
            </div>
          </Action>
          <hr aria-hidden />
          {open &&
            itemSession.sessions.map(info => (
              <React.Fragment key={info.sessionId}>
                <Info
                  key={info.sessionId}
                  session={info}
                  isBetaUser={isBetaUser}
                  removeSessionState={removeSessionState}
                />
                <hr aria-hidden />
              </React.Fragment>
            ))}
        </SessionItemList>
      )}
    </>
  );
};
export default DropDownSession;
